import React from 'react';
import { parse, toSeconds } from 'iso8601-duration';
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm';
import ConcreteDetailsSchema from 'schemas/concreteDetails.schema.json';
import ConcreteTestInformation from 'schemas/ConcreteTestInformation.schema.json';
import { Card, CardContent, CardHeader, Typography, useTheme } from '@material-ui/core';
import { useAppContext } from 'hooks/useAppContext';
import SkeletonForm from 'components/Shared/SkeletonForm';
import { Grid as LayoutGrid } from '@material-ui/core';
import withAppStylesGrid from 'HOCs/withAppStyles';
import MaterialTable from 'material-table';
import { useStyles } from 'components/Shared/DynamicForm';


const ConcreteDetailsTab = ({ orientation, defaultValues, CRUDType, callback, disabledProperties, hiddenProperties }) => {
    const classes = useStyles();
    const { selectedProject, selectedProjectData } = useAppContext();
    const columns = [
        { title: "Break Day", field: "BreakDay" },
        { title: "Comments to Lab", field: "Comments" },
        { title: "ConcGroutId", field: "ConcGroutId", hidden: true },
        { title: "ConcGroutId", field: "ConcGroutId", hidden: true },
    ]
    const title = "Concrete Cylinders"

    const theme = useTheme();

    const concreteRecords = defaultValues.Concrete || [];
    const concreteValues = concreteRecords.length > 0 ? { ...concreteRecords[0] } : {};

    Object.entries(concreteValues).forEach(([key, value]) => {
        try {
            if(key === "TimeBatched" || key === "TimeSampled") {
                const parsedSeconds = toSeconds(parse(value));
                const d = new Date();
                d.setHours(0,0,0,0);
                d.setSeconds(parsedSeconds);
                concreteValues[key] = d;
            }
        } catch(e) {
            // already converted
        }
    });

    const cylinders = concreteValues.Cylinders || [];

    const GridWithAppStyle = withAppStylesGrid(MaterialTable, {
        theme,
        getRecords: cylinders,
        defaultFilters: {}
    })

    return (
        <LayoutGrid container spacing={4} direction="row" style={{ margin: 12, width: "calc(100% - 18px)" }}>
            {
                concreteRecords.length === 0 &&
                <LayoutGrid item lg={12} md={12} sm={12} xs={12}>
                <Card><CardContent><Typography variant="h6">No Concrete details available.</Typography></CardContent></Card>
                </LayoutGrid>
            }
            <LayoutGrid item lg={7} md={7} sm={12} xs={12}>
                <LayoutGrid container spacing={4} direction="column">
                    {
                        concreteRecords.length > 0 &&
                        <>
                            <LayoutGrid item >
                                {
                                    selectedProjectData ?
                                        withExtension(DynamicForm, { title: true, schema: ConcreteDetailsSchema, orientation, defaultValues: concreteValues, disabledProperties, hiddenProperties, readOnly: true, inputVariant: "filled" }) :
                                        <SkeletonForm />
                                }
                            </LayoutGrid>
                            <LayoutGrid item >
                                {
                                    selectedProjectData ?
                                        withExtension(DynamicForm, { title: true, schema: ConcreteTestInformation, orientation, defaultValues: concreteValues, disabledProperties, hiddenProperties, readOnly: true, inputVariant: "filled" }) :
                                        <SkeletonForm />
                                }
                            </LayoutGrid>
                        </>
                    }
                </LayoutGrid>
            </LayoutGrid>
            <LayoutGrid lg={5} md={5} sm={12} xs={12} item>
                {
                    cylinders.length > 0 &&
                    <Card>
                        <CardHeader title="Break Schedule" className={classes.cardHeader}></CardHeader>
                        <CardContent>
                            <GridWithAppStyle
                                columns={columns}
                                title={title}
                                selectedProject={selectedProject}
                                component="Samples"
                                data={cylinders}
                                options={{
                                    toolbar: false,
                                    paging: false
                                }}
                            />
                        </CardContent>
                    </Card>
                }
            </LayoutGrid>
        </LayoutGrid>
    )
}

ConcreteDetailsTab.defaultProps = {
    orientation: "Horizontal",
    callback: () => { },
    defaultValues: {},
    disabledProperties: [],
    hiddenProperties: []
}

export default ConcreteDetailsTab
